import {formFieldValue} from '../selectors/formFieldValue';

export default function() {
  const countryCode = formFieldValue(document, 'country_code');
  if(!countryCode || countryCode.match(/country_code/)) { return 'US'; }
  return countryCode;
}
